import { Children, isValidElement, cloneElement, ReactElement } from 'react';
import { cx } from '@linaria/atomic';
import { ListRowStyles } from '../../list-row.styles';

type TrailingColumnProps = React.PropsWithChildren<{
  className?: string;
  verticalAlign?: 'center' | 'flex-start';
}>;

export const TrailingColumn = ({ verticalAlign = 'center', children, ...rest }: TrailingColumnProps) => {
  const styles = ListRowStyles.TrailingColumn({ verticalAlign });

  return (
    <div {...rest} className={cx(styles, 'trailing-column', rest.className)}>
      {Children.map(
        children,
        (child) =>
          isValidElement(child) &&
          cloneElement(child as ReactElement<{ className: string }>, { className: 'trailing-column-child' })
      )}
    </div>
  );
};
